"use client";
import { PaylioContext } from "@/context/context";
import Image from "@/components/AppImage";
import { useContext } from "react";
import CryptoCard from "../cards/CryptoCard";
import buy_crypto from "/public/images/icon/buy-crypto.png";
import sell_crypto from "/public/images/icon/sell-crypto.png";
import support_icon from "/public/images/icon/support-icon.png";

const cryptoData = [
  {
    id: 1,
    icon: buy_crypto,
    title: "ACH → USDC (Polygon)",
    link: "/deposit-money/step-1",
  },
  {
    id: 2,
    icon: sell_crypto,
    title: "Auto-convert · USDC ↔ POL",
    link: "/exchange/step-1",
  },
];

const CryptoMain = () => {
  const { activeLefMenu } = useContext(PaylioContext);
  return (
    <section
      className={`dashboard-section ${
        activeLefMenu ? "body-collapse" : ""
      } pay crypto`}>
      <div className="overlay pt-120">
        <div className="container-fruid">
          <div className="main-content">
            <div className="head-area d-flex align-items-center justify-content-between">
              <div>
                <h4>Crypto</h4>
                <p className="mdr mb-0 mt-2">
                  Default asset: Polygon USDC. At most one additional
                  auto-convert token (POL) is supported.
                </p>
              </div>
              <div className="icon-area">
                <Image src={support_icon} alt="icon" />
              </div>
            </div>
            <div className="row pb-120">
              {cryptoData.map((itm) => (
                <div key={itm.id} className="col-lg-3 col-md-5">
                  <CryptoCard data={itm} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CryptoMain;
